import { USER_GROUP } from './keyWords.js';
import { NAVIGATION_PATHS } from './navigationPaths.js';

export const GOAL_TYPES_INSIGHTS = [
  'Insights',
  'Reallocation opportunities',
  'Other',
];
export const EXPECTATION_TYPES = ['Expense', 'Revenue', 'Savings'];
export const ACCOUNT_TYPE_EXPENSE_ID = 2;
export const ACCOUNT_TYPE_REVENUE_ID = 4;
export const PERSONNEL_OBJECT_TYPE_ID = 1;
export const NONPERSONNEL_OBJECT_TYPE_ID = 2;
export const SCORE_TYPE_NAME_DEPARTMENT_ID = 1;
export const SCORE_TYPE_NAME_PEER_ID = 2;
export const SCORE_TYPE_NAME_FINAL_ID = 3;
export const COST_TYPES = ['Personnel', 'NonPersonnel'];
export const ITEM_OBJECT_CATEGORIES_DELIMITER = '---';

export const INITIAL_ORGANIZATION_STATE = {
  activeOrganization: '',
  activeBudgetId: null,
  activeCostCenters: [],
};

export const EXPECTATION_DURATIONS = {
  ONE_TIME: 'One time',
  ONGOING: 'Ongoing',
};

export const QUARTILE_DICTIONARY = Object.freeze({
  0: 'No Quartile',
  1: 'Most aligned',
  2: 'More aligned',
  3: 'Less aligned',
  4: 'Least aligned',
});

export const LINE_QUARTILE_SELECTOR = {
  leastAligned: 'Least aligned',
  lessAligned: 'Less aligned',
  moreAligned: 'More aligned',
  mostAligned: 'Most aligned',
};

export const OBJECT_TYPE_DICTIONARY = Object.freeze({
  1: 'Personnel',
  2: 'NonPersonnel',
});

export const RECOMMEND_OPTIONS = [
  { id: SCORE_TYPE_NAME_DEPARTMENT_ID, name: 'Department' },
  { id: SCORE_TYPE_NAME_PEER_ID, name: 'Peer' },
  { id: SCORE_TYPE_NAME_FINAL_ID, name: 'Final' },
];
export const INTERNALLY_USED_FIELD_NAMES = Object.freeze([
  'Cost Type',
  'Account',
  'ProgName',
  'Account type',
  // 'Fund',
  'Cost Center',
  'Name',
  'Cost',
]);

export const CREATE_NEW_SET_INITIAL_VALUES = {
  boxChoiceTypeLabels: ['Timeline', 'Complexity'],
  timeline: [
    {
      name: 'Short term',
    },
    {
      name: 'Long term',
    },
  ],
  complexity: [
    {
      name: 'Low',
    },
    {
      name: 'High',
    },
  ],
  programChangeTypes: [
    { name: 'No recommended change' },
    { name: 'Program efficiency' },
    { name: 'Other insight' },
    { name: 'Service level increase opportunity' },
    { name: 'Service level decrease opportunity' },
    { name: 'Cost recovery opportunity' },
  ],
  authorNoteTypes: [
    {
      description: 'Why are you recommending this insight?',
      isRequired: false,
    },
    {
      description: 'Who will this change impact?',
      isRequired: false,
    },
    {
      description: 'What needs to happen to ensure success?',
      isRequired: false,
    },
    {
      description: 'What resources are required?',
      isRequired: false,
    },
    {
      description: 'Please, include anything else that may be useful',
      isRequired: false,
    },
  ],
  goals: [],
};

export const SHOW_COLUMNS_DEFAULT_VALUES = {
  programInventoryColumns: [
    { name: 'Checkbox', show: true },
    { name: 'Service Type', show: true },
    { name: 'Program Department', show: true },
    { name: 'Program Division', show: true },
    { name: 'Program number', show: true },
    { name: 'Program', show: true },
    { name: 'Description', show: true },
    { name: 'User Group', show: true },
    { name: 'ProgID', show: false },
    { name: 'delete column', show: true },
  ],
  costAllocationColumns: [
    { name: 'Service Type', show: false },
    { name: 'Program Department', show: true },
    { name: 'Program Division', show: true },
    { name: 'Program number', show: false },
    { name: 'Allocation', show: true },
    { name: 'Program', show: true },
    { name: USER_GROUP, show: false },
    { name: 'FTE', show: true },
    { name: 'ProgID', show: false },
  ],
  departmentUserScoreColumns: [
    { name: 'Percent', show: true },
    { name: 'Program', show: true },
    { name: 'Service Type', show: true },
    { name: 'Program Division', show: true },
    { name: 'Program Department', show: true },
  ],
  finalScoreColumns: [
    { name: 'Quartile', show: true },
    { name: 'Service Type', show: true },
    { name: 'Program', show: true },
    { name: 'Peer', show: true },
    { name: 'Department', show: true },
  ],
  insightsColumns: [
    { name: 'Quartile', show: true },
    { name: 'Service Type', show: true },
    { name: 'Program', show: true },
    { name: 'Total cost', show: true },
  ],
  reconciliationTeam: [
    { name: 'Service Type', show: true },
    { name: 'Program', show: true },
    { name: 'Program Division', show: true },
    { name: 'Program Department', show: true },
  ],
  reconciliationDep: [
    { name: 'Service Type', show: true },
    { name: 'Program', show: true },
    { name: 'Program Division', show: true },
    { name: 'Program Department', show: true },
  ],
  itemInventoryColumns: [
    {
      name: 'Item ID',
      show: true,
    },
    {
      name: 'Account ID',
      show: true,
    },
    {
      name: 'Account Type',
      show: true,
    },
    {
      name: 'Account Code',
      show: true,
    },
    {
      name: 'Duration Type',
      show: true,
    },
    {
      name: 'User Group',
      show: true,
    },
    {
      name: 'Number of Items',
      show: true,
    },
    {
      name: 'Fund',
      show: true,
    },
    {
      name: 'Name Meta',
      show: true,
    },
    {
      name: 'Item Meta 1',
      show: true,
    },
    {
      name: 'Item Meta 2',
      show: true,
    },
    {
      name: 'Item Meta 3',
      show: true,
    },
    {
      name: 'Item Comments',
      show: true,
    },
    {
      name: 'Onetime Cost',
      show: true,
    },
    {
      name: 'Ongoing Cost',
      show: true,
    },
    { name: 'Level_1', show: true },
    { name: 'Level_2', show: true },
    { name: 'Level_3', show: true },
    { name: 'Level_4', show: true },
    { name: 'Level_5', show: true },
    { name: 'Level_6', show: true },
    { name: 'Level_7', show: true },
    { name: 'Level_8', show: true },
  ],
  budgeterIndividualRequestsColumns : [
    { name: 'Status', show: true },
    { name: 'Type', show: true },
    { name: 'Account code', show: true },
    { name: 'Item', show: true },
    { name: 'Description', show: true },
    { name: 'Duration type', show: true },
    { name: 'Requested amount', show: true },
    { name: 'Approved amount', show: true },
  ],
  budgeterGroupedRequestsColumns : [
    { name: 'Status', show: true },
    { name: 'Group name', show: true },
    { name: 'Group description', show: true },
  ],
  manageUsersColumns: [
    { name: 'Email', show: true },
    { name: 'First name', show: true },
    { name: 'Last name', show: true },
    { name: USER_GROUP, show: true },
    { name: 'Peer review', show: true },
    { name: 'Access', show: true },
    { name: 'Role', show: true },
  ],
  manageCostCenterColumns: [
    { name: USER_GROUP, show: true },
    { name: 'Users', show: true },
  ],

  organizationEditorColumns: [
    { name: 'ID', show: true },
    { name: 'Organization name', show: true },
    { name: 'Organization type', show: true },
    { name: 'City', show: true },
    { name: 'State/Province', show: true },
    { name: 'Country', show: true },
    { name: 'Status', show: true },
  ],
  manageAdminUsersColumns: [
    { name: 'Email', show: true },
    { name: 'First name', show: true },
    { name: 'Last name', show: true },
    { name: 'Organizations', show: true },
  ],
  lineItemRequestColumns: [
    { name: 'Account code', show: true },
    { name: 'Item', show: true },
    { name: 'Cost type', show: true },
    { name: 'Total item cost', show: true },
    { name: 'Duration type', show: true },
    { name: 'Level_1', show: true },
    { name: 'Level_2', show: true },
    { name: 'Level_3', show: true },
    { name: 'Level_4', show: true },
    { name: 'Level_5', show: true },
    { name: 'Level_6', show: true },
    { name: 'Level_7', show: true },
    { name: 'Level_8', show: true },
  ],
};


export const TABLE_LOCATIONS = {
  programInventory: 'programInventoryColumns',
  programCostAllocation: 'costAllocationColumns',
  departmentScoringReview: 'departmentUserScoreColumns',
  finalScoring: 'finalScoreColumns',
  programInsights: 'insightsColumns',
  peerReviewTeamReconciliation: 'reconciliationTeam',
  peerReviewDepartmentReconciliation: 'reconciliationDep',
  itemInventory: 'itemInventoryColumns',
  budgeterIndividualRequests: 'budgeterIndividualRequestsColumns',
  budgeterGroupedRequests: 'budgeterGroupedRequestsColumns',
  lineItemRequest: 'lineItemRequestColumns',
  manageUsers: 'manageUsersColumns',
  manageCostCenters: 'manageCostCenterColumns',
  organizationEditor: 'organizationEditorColumns',
  manageAdminUsers: 'manageAdminUsersColumns',
};

export const QUESTION_TYPE_IDS = {
  generalQuestions: 1,
  personnelQuestions: 2,
  nonPersonnelQuestions: 3,
};

export const QUESTION_TYPES = {
  GENERAL_QUESTIONS: 'General questions',
  PERSONNEL_QUESTIONS: 'Personnel questions',
  NON_PERSONNEL_QUESTIONS: 'NonPersonnel questions',
  ADDITIONAL_QUESTIONS: 'Additional questions',
};

export const BUDGETER_PHASES_ID = {
  REQUEST_PHASE: 0,
  REVIEW_PHASE: 1,
};

export const BUDGETER_PHASES = ['Request', 'Review'];

export const ORGANIZATION_SETTINGS_KEYS = {
  FTE_CHANGES: 'fte_changes',
};

export const BOX_CHOICE_TYPES = {
  SINGLE_CHOICE: 'Single choice',
  MULTIPLE_CHOICE: 'Multiple choice',
};

export const NO_IMAGE = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot/no-image-available-primary-spot.svg',
  alt: '',
};

export const DIMENSION_SPOT = {
  source: 'https://cdn.forge.tylertech.com/v1/images/spot/dimension-spot.svg',
  alt: 'Organization level',
};

export const ACCOUNT_SPREADSHEET = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot-hero/accounts-spreadsheet-spot-hero.svg',
  alt: 'Manage Organizational hierarchy',
};

export const ADD_FROM_SEARCH_DIALOG_IMAGE = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot/no-search-results-spot.svg',
  alt: 'there is no results found',
};

export const EMPTY_STATE_SPOT = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot-hero/setup-1-empty-state-spot-hero.svg',
  alt: 'Configure Results',
};

export const MANAGE_DATA = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot-hero/setup-1-empty-state-spot-hero.svg',
  alt: 'Manage data',
};

export const PERSONAL_INFORMATION = {
  source: 'https://cdn.forge.tylertech.com/v1/images/spot/person-2-spot.svg',
  alt: 'Personal Information',
};

export const ORGANIZATION_INFORMATION = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot/personalized-spot.svg',
  alt: 'Organization information',
};

export const SUCCESS_DIALOG_IMAGE = {
  source: 'https://cdn.forge.tylertech.com/v1/images/spot/thumbs-up-spot.svg',
  alt: 'thumbs-up',
};

export const SESSION_TIMEOUT = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot-hero/session-timeout-spot-hero.svg',
  alt: 'Session Timeout',
};

export const MANUAL_LOGOUT = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot-hero/logged-off-spot-hero.svg',
  alt: 'Manual Logout',
};

export const SESSION_ENDED = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot/quick-exit-spot.svg',
  alt: 'Session Ended',
};

export const DOWNLOAD_REPORTS = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot/generic-report-spot.svg',
  alt: 'Download Reports',
};

export const NO_DATA_FOUND = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot-hero/general-empty-state-spot-hero.svg',
  alt: 'No Data Found',
};

export const NO_BUDGET_AVAILABLE = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot-hero/accounts-spreadsheet-spot-hero.svg',
  alt: 'No Budget Available',
};

export const NO_SETS_AVAILABLE = {
  source:
    'https://cdn.forge.tylertech.com/v1/images/spot-hero/no-search-results-spot-hero.svg',
  alt: 'No Sets Available',
};

export const ZERO_TOTAL_COST = {
  src: 'https://cdn.forge.tylertech.com/v1/images/spot/not-viewable-spot.svg',
  alt: 'Zero Total Cost',
  message: 'At least one item has to have a total cost greater than zero.',
};

export const EMAIL_MISMATCH_SPOT_IMAGE_SRC = {
  source: 'https://cdn.forge.tylertech.com/v1/images/spot/person-to-person-spot.svg'
};

export const LEVELS_LABELS_NUMBERS = [
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
];

export const PROGRAM_INVENTORY_SERVICE_TYPES = [
  'Community',
  'Governance',
  'Fixed',
];

export const ORGANIZATION_STATUS_LIST = [
  { id: 1, name: 'live' },
  { id: 2, name: 'archive' },
  { id: 3, name: 'test' },
  { id: 4, name: 'sales' },
];

export const REGEX_VALIDATIONS = {
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\S]{6,}$/,
  email: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,4}$/i,
  username: /^[A-Za-z0-9.@\-_]{6,}$/i,
};

export const USER_ROLE = {
  ADMIN: 'admin user',
  SUPER_USER: 'super user',
  DEPARTMENT_USER: 'department user',
};

export const USER_ACCESS = {
  READ_ONLY: 'Read only',
  READ_AND_WRITE: 'Read & write',
};

export const SESSION_TIMERS_CONFIG = {
  sessionTimeout: 45 * 60 * 1000, // 45 minutes
  warningTimeout: 5 * 60 * 1000, // 5 minutes
};

export const GOAL_TYPES = {
  quantitative: 'Quantitative',
  qualitative: 'Qualitative',
};

export const QUANTITATIVE_GOAL_OPTIONS = [
  'Insights',
  'Reallocation opportunities',
  'Other',
];

export const DURATION_TYPE_ID = {
  ONGOING: 2,
  ONETIME: 1,
};

export const DEFAULT_TABLE_OFFSET = '65';
export const TABLE_OFFSETS = {
  [NAVIGATION_PATHS.BUDGET_LINE_ITEM_EDITOR]: '132',
  [NAVIGATION_PATHS.USER_ACTIVITY]: '145',
  [NAVIGATION_PATHS.COST_ALLOCATION]: '121',
  [NAVIGATION_PATHS.BUDGET_REQUESTS]: '114',
};

export const UPLOAD_TABLE_OFFSETS = {
  [NAVIGATION_PATHS.PROGRAM_INVENTORY]: '65',
  [NAVIGATION_PATHS.MANAGE_USERS]: '55',
  [NAVIGATION_PATHS.FINAL_REVIEW]: '280',
  [NAVIGATION_PATHS.COST_ALLOCATION]: '211',
};

export const CUSTOM_CSS_VARIABLES = {
  ALTERNATIVE_WIDTH: '--alternative-width',
  TABLE_OFFSET: '--table-offset',
};

export const CUSTOM_CSS_VARIABLES_VALUES = {
  BUDGET_ACCESS_SWITCH: '500px',
  CONFIGURE_BUDGET_CONTAINER_NAV_OPEN: '100%',
  CONFIGURE_BUDGET_CONTAINER_NAV_CLOSED: '80%',
};

export const BUDGETER_COST_MANIPULATOR_MODES = {
  INCREASE_BY_COST: 'Increase by cost',
  DECREASE_BY_COST: 'Decrease by cost',
  INCREASE_BY_TOTAL: 'Increase by total',
  DECREASE_BY_TOTAL: 'Decrease by total',
};

export const HIERARCHY_LABELS = {
  PERSONNEL: 'Personnel',
  NON_PERSONNEL: 'Nonpersonnel',
  ORGANIZATIONAL: 'Organizational',
};

export const AI_ICON_NAME = 'forge-ai-icon';
export const SUPPORT_SLOT = 'support-text';
export const REQUIRED_FIELD_TEXT = 'This field is required';

export const REQUESTER_DEFAULT_PAGE_TOOLTIP_ANCHOR_ID =
  'REQUESTER_DEFAULT_PAGE_TOOLTIP_ANCHOR_ID';

export const CHUNK_SIZE = 500;

export const LIST_OF_ACCESS_ICONS_IN_SETTINGS = [
  'Organizational hierarchy',
  'Name conventions',
  'Manage users',
  'Manage user access',
  'User activity',
  'Configure budget',
  'Configure results',
  'Configure insights',
  'Configure requests'  
];

export const TABLE_COLUMN_WIDTH = {
  XS: 100,
  MD: 120,
  LG: 150,
  XL: 200,
  XXL: 500,
  DEFAULT: 300,
};

export const DEFAULT_TOAST_DURATION = 5000;
export const NO_BUDGET = 'no-budget';

export const EDIT_TYPE_LABELS = {
  EDIT: 'Edit',
  ADD: 'Add',
  DELETE: 'Delete',
  IGNORE: ''
};

export const ELEMENTS_TO_INTERACT_WITH = ['FORGE-BUTTON', 'FORGE-ICON'];
